<template lang="pug">
  component(:is="view" v-if="variables" :vars="variables")
</template>

<script>
import { mapGetters } from 'vuex'
import minioAPI from '@/services/minio'
import dictionariesAPI from '@/services/dictionaries'

export default {
  name: 'ProcessInfoController',

  provide() {
    const that = this
    return {
      ctrl: {
        getDownloadUrls(files) {
          if (files) {
            return that.getDownloadUrls(files)
          }
          return null
        },
        getDictionary(dictionary, payload) {
          return that.getDictionary(dictionary, payload)
        },
        get(name, alt) {
          return that.variables[name] ? that.variables[name].value : alt
        },
        t(key) {
          return that.$tf(`${that.definition.key}.${key}`)
        },
        routerPush(arg) {
          return that.$router.push(arg)
        },
        getCurrentUser() {
          return Object.assign(that.profile, { groups: that.groups, locale: that.locale })
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      view: 'process/view',
      variables: 'process/variables',
      definition: 'process/definition',
      profile: 'auth/profile',
      groups: 'auth/groups',
      locale: 'tools/locale',
    }),
  },

  methods: {
    getDownloadUrls(files) {
      return minioAPI.presignedGetObjectUrls(files)
    },
    getDictionary(dictionary, payload) {
      return dictionariesAPI.request(dictionary, payload)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/process/ProcessInfoController.vue